"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteSubscriptionArgsValidator = exports.deleteSubscriptionArgsSchema = exports.updateSubscriptionArgsValidator = exports.updateSubscriptionArgsSchema = exports.createSubscriptionArgsValidator = exports.createSubscriptionArgsSchema = exports.subscriptionConfigValidator = exports.subscriptionConfigSchema = void 0;
var suretype_1 = require("suretype");
var common_1 = require("../common");
exports.subscriptionConfigSchema = suretype_1.v.object({
    apps: suretype_1.v.array(common_1.idSchema).minItems(1).unique(true).required(),
    title: suretype_1.v.string().minLength(1).maxLength(30).required(),
    subTitle: suretype_1.v.string().minLength(1).maxLength(50).required(),
    description: suretype_1.v.string().minLength(1).maxLength(1000).required(),
    meta: suretype_1.v.unknown(),
    pricing: suretype_1.v.object({
        currency: suretype_1.v.string().enum("CHF", "USD", "EUR").required(),
        price: suretype_1.v.number().gte(0).required(),
    }).required(),
    validity: suretype_1.v.object({
        length: suretype_1.v.number().gte(1).required(),
        unit: suretype_1.v.string().enum("month", "year").required(),
    }).required(),
    autoRenew: suretype_1.v.boolean().required(),
    restrictions: suretype_1.v.object({
        emails: suretype_1.v.array(suretype_1.v.string().format("email")).required(),
        countries: suretype_1.v.array(suretype_1.v.string().enum("DE", "CH", "US")).required(),
    }).required()
});
exports.subscriptionConfigValidator = (0, suretype_1.compile)(exports.subscriptionConfigSchema);
exports.createSubscriptionArgsSchema = suretype_1.v.object({
    subscriptionId: common_1.idSchema.required(),
    subscriptionConfig: exports.subscriptionConfigSchema.required(),
});
exports.createSubscriptionArgsValidator = (0, suretype_1.compile)(exports.createSubscriptionArgsSchema);
exports.updateSubscriptionArgsSchema = suretype_1.v.object({
    subscriptionId: common_1.idSchema.required(),
    subscriptionConfig: exports.subscriptionConfigSchema.required(),
});
exports.updateSubscriptionArgsValidator = (0, suretype_1.compile)(exports.updateSubscriptionArgsSchema);
exports.deleteSubscriptionArgsSchema = suretype_1.v.object({
    subscriptionId: common_1.idSchema.required(),
});
exports.deleteSubscriptionArgsValidator = (0, suretype_1.compile)(exports.deleteSubscriptionArgsSchema);
